import { useCallback, useState } from 'react';

function getDefaultTheme() {
  return 'light';
}

export function useTheme() {
  const [theme, setTheme] = useState(getDefaultTheme);

  const toggleTheme = useCallback(() => {
    setTheme((t) => {
      const next = t === 'dark' ? 'light' : 'dark';
      try {
        localStorage.setItem('bv-theme', next);
      } catch {
        /* ignore */
      }
      return next;
    });
  }, []);

  return { theme, toggleTheme };
}
